module.exports = __webpack_public_path__ + "static/media/RabbitStickers.ff110063.jpg";